import { useEffect, useState } from "react";
import SubFilters from "./inc/SubFilters";
import { CSSTransition } from "react-transition-group";

const FilterItem = ({
  filter,
  filtersState,
  filterName,
  setFiltersState,
  itemDiv,
  filters,
  setSelectedInstitution,
  filtersKeys,
}) => {
  const [isActive, setIsActive] = useState(false);

  //--- Manage active state used to for current filter item
  useEffect(() => {
    if (filtersState[filterName] && filtersState[filterName].length > 0) {
      if (filtersState[filterName].includes(filter.slug)) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    } else {
      setIsActive(false);
    }
  }, [filtersState]);

  const handleFilter = (id) => {
    let slugifiedName = "";
    //--- Reset selected Institution on filter input
    setSelectedInstitution(null);

    //--- get the slug corresponding to the name
    for (const filter of filters[filterName].values) {
      if (id === filter.name) {
        slugifiedName = filter.slug;
      }
    }

    //--- Add or remove the filter slug into filterState
    let newFilters = JSON.parse(JSON.stringify(filtersState));
    if (
      filtersState[filterName].indexOf(slugifiedName) === -1 ||
      filtersState[filterName].length === 0
    ) {
      setFiltersState((prevfilter) => ({
        ...prevfilter,
        [filterName]: [...prevfilter[filterName], slugifiedName],
      }));
      newFilters[filterName].push(slugifiedName);
    } else if (newFilters[filterName].indexOf(slugifiedName) > -1) {
      newFilters[filterName] = newFilters[filterName].filter(
        (elt) => elt !== slugifiedName
      );
      setFiltersState(newFilters);
    }
    setIsActive((prev) => !prev);
  };

  // console.log(isActive);

  return (
    <>
      <div key={filter.id} className={itemDiv}>
        <div
          className={`generic-filter__item ${isActive ? "active" : ""}`}
          key={filter.id}
          onClick={() => handleFilter(filter.name)}
        >
          {filters[filterName]["icon"] !== "" && (
            <span className="generic-filter__item--svg">
              <img
                src={filter["icon"]}
                alt=""
                style={{ width: "25px", height: "25px" }}
              />
            </span>
          )}
          <div className="generic-filter__item--name">{filter.name}</div>
        </div>
      </div>
      {/* {isActive && ( */}
      <CSSTransition
        in={isActive}
        timeout={200}
        classNames={{
          appear: "fade-appear",
          appearActive: "fade-active-appear",
          appearDone: "fade-done-appear",
          enter: "fade-enter",
          enterActive: "fade-active-enter",
          enterDone: "fade-done-enter",
          exit: "fade-exit",
          exitActive: "fade-active-exit",
          exitDone: "fade-done-exit",
        }}
        //classNames="fade"
      >
        <SubFilters
          filter={filter}
          filtersState={filtersState}
          filterName={filterName}
          setFiltersState={setFiltersState}
          itemDiv={itemDiv}
          filters={filters}
          setSelectedInstitution={setSelectedInstitution}
          filtersKeys={filtersKeys}
        />
      </CSSTransition>
      {/* )} */}
    </>
  );
};

export default FilterItem;
